import BaseGrid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';

const Grid = BaseGrid;

Grid.propTypes = {
  component: PropTypes.elementType,
  lg: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
};

export default Grid;
